import { SVGProps } from 'react';

export function EnterLineIcon({ className, ...props }: SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" className={className} {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5 8.87501C5 8.97447 5.03951 9.06984 5.10984 9.14017L6.85984 10.8902C7.00628 11.0366 7.24372 11.0366 7.39017 10.8902C7.53661 10.7437 7.53661 10.5063 7.39017 10.3598L6.28033 9.25001H9.875C10.4963 9.25001 11 8.74632 11 8.12501V5.375C11 5.1679 10.8321 5 10.625 5C10.4179 5 10.25 5.1679 10.25 5.375V8.12501C10.25 8.33211 10.0821 8.50001 9.875 8.50001H6.28033L7.39017 7.39017C7.53661 7.24373 7.53661 7.00628 7.39017 6.85984C7.24372 6.71339 7.00628 6.71339 6.85984 6.85984L5.10984 8.60985C5.03951 8.68017 5 8.77555 5 8.87501Z"
        fill="#99A0AE"
      />
    </svg>
  );
}
